import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaTiktok, FaInstagram, FaTwitter } from "react-icons/fa";
import "./Footer.css";

 export const Footer = () => {
const currentYear = new Date().getFullYear();


useEffect(() => {
  // -------- FOOTER 300x250 --------
  const footerAd = document.getElementById("footer-ad");
  
  if (footerAd) {
   
    footerAd.innerHTML = "";

    const s1 = document.createElement("script");
    s1.innerHTML = `
      atOptions = {
        'key' : 'bb7be3970dafee2f43054de442bd848c',
        'format' : 'iframe',
        'height' : 250,
        'width' : 300,
        'params' : {}
      };
    `;

    const s2 = document.createElement("script");
    s2.src = "https://www.highperformanceformat.com/bb7be3970dafee2f43054de442bd848c/invoke.js";
    s2.async = true;

    footerAd.appendChild(s1);
    footerAd.appendChild(s2);
  }

  // -------- MOBILE 320x50 --------
  const mobileAd = document.getElementById("mobile-sticky-ad");

  if (mobileAd && window.innerWidth < 768) {
    mobileAd.innerHTML = "";

    const s3 = document.createElement("script");
    s3.innerHTML = `
      atOptions = {
        'key' : 'f771b4c301910b8a3e1d4985ad431959',
        'format' : 'iframe',
        'height' : 50,
        'width' : 320,
        'params' : {}
      };
    `;

    const s4 = document.createElement("script");
    s4.src = "https://www.highperformanceformat.com/f771b4c301910b8a3e1d4985ad431959/invoke.js";
    s4.async = true;

    mobileAd.appendChild(s3);
    mobileAd.appendChild(s4);
  }

}, []);


  return (
    <footer className="footer" id="footer">
      {/* Ad Slot Before Footer */}
      <div id="footer-ad" className="ad-placeholder">
        Advertisement Space
      </div>

      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* Column 1: Logo & Social */}
            <div className="footer-column">
              <h3 className="footer-logo">WTF⚡Horoscope</h3>
              <p className="footer-tagline">
                No fake positivity. Just cosmic truth.
              </p>
              <div className="social-links">
                <a
                  href="https://tiktok.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  title="TikTok"
                >
                  <FaTiktok />
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  title="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                  title="Twitter/X"
                >
                  <FaTwitter />
                </a>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div className="footer-column">
              <h4 className="footer-column-title">Quick Links</h4>
              <ul className="footer-links">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/#zodiac-grid">Zodiac Signs</a>
                </li>
                <li>
                  <a href="/#how-it-works">How It Works</a>
                </li>
                <li>
                  <a href="/#zodiac-grid">All Signs</a>
                </li>
              </ul>
            </div>

            {/* Column 3: Legal */}
            <div className="footer-column">
              <h4 className="footer-column-title">Legal</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/disclaimer">Disclaimer</Link>
                </li>
                <li>
                  <Link to="/cookie-policy">Cookie Policy</Link>
                </li>
              </ul>
            </div>

            {/* Column 4: About */}
            <div className="footer-column">
              <h4 className="footer-column-title">About</h4>
              <ul className="footer-links">
                <li>
                  <a href="#about">What is WTFHoroscope</a>
                </li>
                <li>
                  <a href="mailto:hello@wtfhoroscope.com">Contact Us</a>
                </li>
                <li>
                  <a href="mailto:advertise@wtfhoroscope.com">Advertise</a>
                </li>
                <li>
                  <a href="#blog">Blog</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <p className="footer-copyright">
            © {currentYear} WTFHoroscope.xyz — Made with 💀 and cosmic energy 
          </p>
        </div>
      </div>

      {/* Mobile Sticky Ad Slot */}
      <div id="mobile-sticky-ad" className="ad-placeholder mobile-sticky-ad">
        
      </div>
    </footer>
  );
};
